import { NAV_COLOUR_ACCENT } from "@/app/(general-header)/home/winnersFeed/winnersFeedColors";

export function formatCurrency(value: number): string {
  return value >= 1000
    ? `£${value.toLocaleString("en-GB", { maximumFractionDigits: 0 })}`
    : `£${value.toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function formatTicketPrice(value: number): string {
  if (value === 0) return "FREE";
  return `£${value.toFixed(2)}`;
}

export function getAccentColor(navigationColour: string): string {
  return NAV_COLOUR_ACCENT[navigationColour] ?? "#FF8200";
}

const FALLBACK_IMAGES: Record<string, string> = {
  IW: "/assets/images/win/fallback-instant-wins.webp",
  IA: "/assets/images/win/fallback-instant-wins.webp",
  IB: "/assets/images/win/fallback-instant-wins.webp",
  IC: "/assets/images/win/fallback-instant-wins.webp",
  EW: "/assets/images/win/fallback-easy-wins.webp",
  RW: "/assets/images/win/fallback-easy-wins.webp",
  SC: "/assets/images/win/fallback-subscribers.webp",
};

export function getFallbackImage(prefix: string): string | null {
  return FALLBACK_IMAGES[prefix] ?? null;
}

export const PASS_LABEL: Record<string, string> = {
  Essential: "Pass Essential",
  Ultimate: "Pass Ultimate",
  Premium: "Pass Premium",
};
